module.exports = flarum.extensions['davwheat-virtual-authors'];